<template>
<!-- 基本信息组件 -->
<div class="base-info-wrap">
  <div class="search-wrap">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-date-picker
          v-model="timeArr"
          type="daterange"
          size="mini"
          :clearable="false"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </el-col>
      <el-col :span="16">
        <div class="search-btns">
          <el-button size="mini" @click="handlePreWeek" class="week-btn">上一周</el-button>
          <el-button size="mini" @click="handleNextWeek" class="week-btn">下一周</el-button>
          <el-button type="primary" size="mini" class="btn-bg" @click="handleSearch">搜索</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="info-content">
    <p class="base-title">基本表单</p>
    <el-table
      v-if="timeHeadList.length"
      :data="tableData"
      :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}"
      style="width:100%">
      <el-table-column
        label=""
        class-name="first-column">
        <template slot-scope="scope">
          <!-- 重点标识标记参数&scope.$index === 0为身高展示重点标识  -->
          <span class="import" v-if="indicatorNames.indexOf('身高') > -1 && scope.$index === 0">重点</span>
          <span class="import" v-if="indicatorNames.indexOf('体重') > -1 && scope.$index === 1">重点</span>
          <span class="import" v-if="indicatorNames.indexOf('BMI') > -1 && scope.$index === 2">重点</span>
          <span v-if="scope.$index === 0">身高 cm</span>
          <div v-if="scope.$index === 1">
            <span style="display:block">体重 kg</span>
            <span style="display:block;color:#1A7BFC;font-size:10px;" @click="handleShowPicTable(1)">查看图表</span>
          </div>
          <div v-if="scope.$index === 2">
            <span style="display:block">BMI kg/m²</span>
            <span style="display:block;color:#1A7BFC;font-size:10px;" @click="handleShowPicTable(2)">查看图表</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in timeHeadList"
        :key="index"
        :prop="item"
        :label="item"
        align="center">
      </el-table-column>
    </el-table>
    <div class="noData" v-if="timeHeadList.length === 0">
      <img src="@/assets/images/null.png" />
      <span>暂无数据</span>
    </div>
  </div>

  <el-dialog
    title=""
    :visible.sync="showPicTable"
    :close-on-click-modal="false"
    width="600px"
    :before-close="handleClose">
    <ul class="tab-wrap">
      <li v-for="(item,index) in tabList"
          :key="index"
          :class="activeTab === item? 'active-bg':''"
          @click="changeTab(item)">{{item}}</li>
    </ul>
    <div v-if="mark === 1">
      <ve-line v-if="activeTab === '折线图'" :colors="['#1A7BFC']" :data="chartData"></ve-line>
      <ve-histogram v-if="activeTab === '柱状图'" :colors="['#1A7BFC']" :data="chartData"></ve-histogram>
    </div>
    <div v-if="mark === 2">
      <ve-line v-if="activeTab === '折线图'" :colors="['#1A7BFC']" :data="bmiChartData"></ve-line>
      <ve-histogram v-if="activeTab === '柱状图'" :colors="['#1A7BFC']" :data="bmiChartData"></ve-histogram>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {getBmiWeightList} from "@/api/InfoMonitor"
// import VeLine from '/node_modules/v-charts/lib/line.common'
// import * as echarts from 'echarts/lib/echarts'
import VeLine from 'v-charts/lib/line.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import moment from 'moment'
export default {
  name:"baseInfo",
  components: {
    VeLine,
    VeHistogram
  },
  props:{
    userData:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      tabList:['柱状图','折线图'],
      chartData: {
        columns: ['date', '体重'],
        rows: []
      },
      bmiChartData: {
        columns: ['date', 'BMI'],
        rows: []
      },
      showPicTable: false,
      activeTab: '折线图',
      indicatorNames: [],
      timeHeadList: [],
      tableData: [{},{},{}],
      timeArr: [
        moment().subtract('days', 6).format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      picData: [],
      mark: 1,
      showPic: false
    }
  },
  watch: {
    'userData.patientId': {
      handler(newVal,oldVal) {
        this.getBaseInfoTableData()
      },
      deep: true
    }
  },
  created() {
    // this.getTimeArr()
    if (this.userData.patientId) {
      this.getBaseInfoTableData()
    }
  },
  methods: {
    handleSearch() {
      this.getBaseInfoTableData()
    },
    changeTab(item) {
      this.activeTab = item
    },
    async getBaseInfoTableData() {
      let { code, data: { indicatorNames, patientBmiVOS } } = await getBmiWeightList({
        endDate: this.timeArr[1],
        startDate: this.timeArr[0],
        patientId: this.userData.patientId
      })
      if (code === 0) {
        this.tableData[0] = {}
        this.tableData[1] = {}
        this.tableData[2] = {}
        this.picData = patientBmiVOS
        this.indicatorNames = indicatorNames
        this.timeHeadList = patientBmiVOS.map(v => v.turnoverDate)
        patientBmiVOS.forEach(ele => {
          this.tableData[0][ele.turnoverDate] = ele.height
          this.tableData[1][ele.turnoverDate] = ele.weight
          this.tableData[2][ele.turnoverDate] = ele.bmi
        })
      }
    },
    handleClose() {
      this.showPicTable = false
    },
    handleShowPicTable(flag) {
      this.mark = flag
      this.chartData.rows = []
      this.bmiChartData.rows = []
      this.activeTab = '折线图'
      if (flag === 1) {
        // 体重
        this.picData.forEach(v => {
          this.chartData.rows.push({
            date: v.turnoverDate,
            体重: v.weight
          })
        })
      }
      if (flag === 2) {
        // bmi
        this.picData.forEach(v => {
          this.bmiChartData.rows.push({
            date: v.turnoverDate,
            BMI: v.bmi
          })
        })
      }
      this.showPicTable = true
    },
    handlePreWeek() {
      this.timeArr = [
        moment(this.timeArr[0]).subtract('days', 6).format('YYYY-MM-DD'),
        moment(this.timeArr[0]).format('YYYY-MM-DD')
      ]
      this.getBaseInfoTableData()
    },
    handleNextWeek() {
      this.timeArr = [
        moment(this.timeArr[1]).format('YYYY-MM-DD'),
        moment(this.timeArr[1]).add('days', 6).format('YYYY-MM-DD')
      ]
      this.getBaseInfoTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.base-info-wrap {
  height: 100%;
  .base-title {
    margin-bottom:14px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .search-wrap {
    background-color: #FFFFFF;
    padding: 15px;
  }
  .info-content {
    height: calc(100% - 88px);
    // margin-top: 16px;
    padding: 17px 16px;
    background-color: #FFFFFF;
  }
  .btn-bg {
    background-color: #1A7BFC;
  }
  .active-bg {
    background-color: #1A7BFC;
    color: #FFFFFF !important;
  }
  .tab-wrap {
    padding: 10px 15px;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    // border-radius: 4px;
    li {
      padding: 5px 10px;
      color: #1A7BFC;
      border: 1px solid #1A7BFC;
    }
  }
}
/deep/.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
.noData{
  width: 106px;
  // position: absolute;
  // left: 50%;
  // top: 0;
  margin: 0 auto;
  margin-top: 100px;
  img{
    width: 100%;
    height: 99px;
  }
  span{
    width: 100%;
    display: block;
    text-align: center;
    color: #999999;
    font-size: 12px;
  }
}
.week-btn {
  color: #1A7BFC;
  border: 1px solid #1A7BFC;
}
// 重点标识
/deep/.first-column {
  .cell {
    display: flex;
    // position: relative;
    align-items: center;
    padding-left: 54px;
    padding-bottom: 3px;
    .import {
      position: absolute;
      left: 10px;
      // top: 0;
      font-size: 12px;
      height: 26px;
      color: #1A7BFC;
      background: #E9F2FE;
      border: 1px solid #95C2FC;
      border-radius: 2px;
      padding: 0 4px;
    }
  }
}
</style>
<style>
.first-column {
  background-color: rgb(250, 250, 250) !important;
}
</style>